document.addEventListener('DOMContentLoaded', function () {
  // Use event delegation on the document or a stable parent
  // Attach the click listener only to the menu wrapper, using event delegation for its buttons
  const menuWrapper = document.getElementById('component-shop-skincare-menu');
  if (menuWrapper) {
    menuWrapper.addEventListener('click', function (event) {
      const button = event.target.closest('.button');
      if (button) {
        menuWrapper.classList.toggle('is-open');
      }
    });
  }

  // Handle blur with delegation
  document.addEventListener('focusout', function (event) {
    const wrapper = event.target.closest('#component-shop-skincare-menu');

    if (wrapper && event.target.classList.contains('button')) {
      if (!wrapper.contains(event.relatedTarget)) {
        wrapper.classList.remove('is-open');
      }
    }
  });
});